import { render, staticRenderFns } from "./trendPL3.vue?vue&type=template&id=583ef58b"
import script from "./trendPL3.vue?vue&type=script&lang=js"
export * from "./trendPL3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports